import { GetScore, Lifter, Meet } from "types";
import { toKg } from "util/conversions";
import { getTotal } from "util/lifterHelper";
import { isLbsMeet } from "util/meetHelper";
import { ageCoef } from "./age";

const params = {
  MALE: {
    a: -216.0475144,
    b: 16.2606339,
    c: -0.002388645,
    d: -0.00113732,
    e: 0.00000701863,
    f: -0.00000001291,
  },
  FEMALE: {
    a: 594.31747775582,
    b: -27.23842536447,
    c: 0.82112226871,
    d: -0.00930733913,
    e: 0.00004731582,
    f: -0.00000009054,
  },
};

export const wilksCoef = function (lifter: Lifter, meet: Meet) {
  let bodyWeight = lifter.bodyWeight;

  if (isLbsMeet(meet)) {
    bodyWeight = toKg(bodyWeight);
  }

  const gender = lifter.gender;

  if (!bodyWeight || !gender) {
    return 0;
  }

  if (gender === "MX") {
    return 0;
  }

  const p = params[gender];

  return (
    500.0 /
    (p.a +
      p.b * bodyWeight +
      p.c * Math.pow(bodyWeight, 2) +
      p.d * Math.pow(bodyWeight, 3) +
      p.e * Math.pow(bodyWeight, 4) +
      p.f * Math.pow(bodyWeight, 5))
  );
};

export const getWilksPoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  if (isLbsMeet(meet)) {
    total = toKg(total);
  }

  return total * wilksCoef(lifter, meet);
};

export const getWilksAndAgePoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  return (
    getWilksPoints({ lifter, division, meet, forecasted }) *
    ageCoef(lifter, meet)
  );
};
